const EXTERNAL = {
  id: 0
};
const SHA1 = {
  id: 0x8004
};
export const HASH_ALGORITHMS = {
  EXTERNAL,
  SHA1
};